<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.5 23.5">
		<path fill="currentColor" d="M16.75 23.5h-14A2.7528 2.7528 0 0 1 0 20.75v-9A2.7528 2.7528 0 0 1 2.75 9h14a2.7528 2.7528 0 0 1 2.75 2.75v9a2.7528 2.7528 0 0 1-2.75 2.75Zm-14-13a1.25116 1.25116 0 0 0-1.25 1.25v9A1.25116 1.25116 0 0 0 2.75 22h14A1.25116 1.25116 0 0 0 18 20.75v-9a1.25116 1.25116 0 0 0-1.25-1.25Z"/>
		<path fill="currentColor" d="M15.833 9.75h-1.5V6.0835a4.58326 4.58326 0 1 0-9.16651 0V9.75h-1.5V6.0835a6.08326 6.08326 0 1 1 12.16651 0Z"/>
		<path fill-rule="evenodd" d="M9.75 18.25a2 2 0 1 0-2-2 2 2 0 0 0 2 2Z"/>
	</svg>
</template>
